histories-show
  .date { date() }
  .version(class="version_{opts.version}" if="{opts.version == 1}")
    histories-order-created.history(if="{this.opts.event=='order_created'}" tag-scope="{this.tagScope}")
    histories-order-updated.history(if="{this.opts.event=='order_updated'}" tag-scope="{this.tagScope}")
    histories-orders-phase-created.history(if="{this.opts.event=='orders_phase_created'}" tag-scope="{this.tagScope}")
    histories-orders-phase-updated.history(if="{this.opts.event=='orders_phase_updated'}" tag-scope="{this.tagScope}")
    histories-orders-phase-destroyed.history(if="{this.opts.event=='orders_phase_destroyed'}" tag-scope="{this.tagScope}")
    histories-line-created.history(if="{this.opts.event=='line_created'}" tag-scope="{this.tagScope}")
    histories-line-destroyed.history(if="{this.opts.event=='line_destroyed'}" tag-scope="{this.tagScope}")
    histories-schedule-created.history(if="{this.opts.event=='schedule_created'}" tag-scope="{this.tagScope}")
    histories-schedule-updated.history(if="{this.opts.event=='schedule_updated'}" tag-scope="{this.tagScope}")
    histories-schedule-destroyed.history(if="{this.opts.event=='schedule_destroyed'}" tag-scope="{this.tagScope}")
    histories-task-created.history(if="{this.opts.event=='task_created'}" tag-scope="{this.tagScope}")
    histories-task-updated.history(if="{this.opts.event=='task_updated'}" tag-scope="{this.tagScope}")
    histories-task-destroyed.history(if="{this.opts.event=='task_destroyed'}" tag-scope="{this.tagScope}")
    histories-taskable-updated.history(if="{this.opts.event=='taskable_updated'}" tag-scope="{this.tagScope}")
    histories-tasks-memo-created.history(if="{this.opts.event=='memo_created'}" tag-scope="{this.tagScope}")
    histories-tasks-memo-updated.history(if="{this.opts.event=='memo_updated'}" tag-scope="{this.tagScope}")
    histories-tasks-memo-destroyed.history(if="{this.opts.event=='memo_destroyed'}" tag-scope="{this.tagScope}")
    histories-approval-required-to-seller.history(if="{this.opts.event=='approval_required_to_seller'}" tag-scope="{this.tagScope}")
    histories-approval-required-to-sales-manager.history(if="{this.opts.event=='approval_required_to_sales_manager'}" tag-scope="{this.tagScope}")
    histories-approval-required-to-exective.history(if="{this.opts.event=='approval_required_to_exective'}" tag-scope="{this.tagScope}")
    histories-approval-approved-by-seller.history(if="{this.opts.event=='approval_approved_by_seller'}" tag-scope="{this.tagScope}")
    histories-approval-canceled-by-seller.history(if="{this.opts.event=='approval_canceled_by_seller'}" tag-scope="{this.tagScope}")
    histories-approval-approved-by-sales-manager.history(if="{this.opts.event=='approval_approved_by_sales_manager'}" tag-scope="{this.tagScope}")
    histories-approval-canceled-by-sales-manager.history(if="{this.opts.event=='approval_canceled_by_sales_manager'}" tag-scope="{this.tagScope}")
    histories-approval-approved-by-exective.history(if="{this.opts.event=='approval_approved_by_exective'}" tag-scope="{this.tagScope}")
    histories-approval-canceled-by-exective.history(if="{this.opts.event=='approval_canceled_by_exective'}" tag-scope="{this.tagScope}")
    .test(style="font-size: 10px; color: #DDD;") { this.opts.event }
  script(type="typescript").
    this.mixin('histories.show')
  style(scoped).
    :scope {
      display: block;
    }
    .date {
      font-size: 10px;
      color: #888;
      margin-top: 7px;
    }
    .version {
      display: block;
    }
    .history {
      display: block;
      position: relative;
      margin-top: 4px;
    }
    .created_at {
      font-size: 8px;
      position: absolute;
      left: 0;
      top: -8px;
    }
    .date-user {
      font-size: 8px;
      position: absolute;
      left: 0;
      top: -8px;
    }
